import { parseInt } from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import SignaturesGql from '@/extensions/communication/store/graphql/queries/Signatures.gql';

/**
 * Signatures are WRITTEN with their CMS (the communication settings tab stages
 * the list, CP_UpdateCms saves it); this is the read the mailbox, POS and
 * composer pickers use.
 */
export default {
    fetchList: cmsID =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({ query: SignaturesGql, variables: { cms_id: parseInt(cmsID) }, fetchPolicy: 'network-only' })
                .then(({ data }) => resolve(data.EX_COMM_Signatures))
                .catch(err => reject(err));
        })
};
